// extracted by mini-css-extract-plugin
export var container = "Callout-module--container--ba8cc";
export var title = "Callout-module--title--12857";